import {krzysztofJaniszewski} from "../../people/krzysztof_janiszewski";

export const psychoTermsExplained = {
    'meta': {
        'title': 'Różnice między psychologią, psychiatrią a psychoterapią | Blog | COLLIGO',
        'description': 'Artykuł wyjaśniający różnice między psychologią, psychiatrią a psychoterapią, ich role, metody pracy i momenty, w których warto z nich skorzystać.'
    },
    'title': 'Różnice między psychologią, psychiatrią a psychoterapią',
    'date': '2023-10-05',
    'readingTime': 2,
    'author': krzysztofJaniszewski,
    'url': {
        'address': '/blog/roznice-miedzy-psychologia-psychiatria-a-psychoterapia/',
        'title': 'Różnice między psychologią, psychiatrią a psychoterapią | Blog | COLLIGO',
        'name': 'Różnice między psychologią, psychiatrią a psychoterapią'
    },
    'image': {
        'url': '/images/blog/psychiatraia-psychoterapia-roznice.webp',
        'width': 886,
        'height': 295,
        'alt': 'Diagnostyka autyzmu'
    },
    'opengraph': {
        'image': {
            'url': null,
            'width': 150,
            'height': 150,
            'alt': 'Artykuł wyjaśniający różnice między psychologią, psychiatrią a psychoterapią, ich role, metody pracy i momenty, w których warto z nich skorzystać.'
        }
    }
}